import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/video/wtm_site_music_1280.mp4'
import _imports_1 from '@/assets/img/video_poster.png'


const _withScopeId = n => (_pushScopeId("data-v-e527a912"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "main-visual" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "title-text container" }, [
  /*#__PURE__*/_createElementVNode("h4", null, "VSinger"),
  /*#__PURE__*/_createElementVNode("hr"),
  /*#__PURE__*/_createElementVNode("h2", null, "角巻わため"),
  /*#__PURE__*/_createElementVNode("h4", null, "Tsunomaki Watame"),
  /*#__PURE__*/_createElementVNode("hr")
], -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "bg-movie-area" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "bg-movie" }, [
    /*#__PURE__*/_createElementVNode("video", {
      src: _imports_0,
      poster: _imports_1,
      loop: "",
      autoplay: "",
      muted: "",
      playsinline: ""
    })
  ])
], -1))
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, _hoisted_4))
}